<template id="huv-sfv-status-report">
    <section class="central-background">
        <div>
            <div class="py-0 d-flex justify-content-center third-level-nav">
                <div class="horizontal-nav-bar rounded-top">
                    <div
                        class="d-flex bg-white rounded-top"
                        id="solution-tab"
                        role="tablist"
                        aria-orientation="horizontal"
                    >
                        <a
                            v-for="tab in tabs"
                            :class="`nav-link d-flex justify-content-between align-items-center 
                                active
                            `"
                            :id="`v-pills-${tab.id}`"
                            data-toggle="pill"
                            href="javascript:void(0)"
                            role="tab"
                            :key="tab.id"
                            aria-selected="true"
                        >
                            {{ tab.name }}
                            <a
                                tabindex="0"
                                href="javascript:void(0);"
                                role="button"
                                v-custom-popover="{ content: hopeDeclaration }"
                            >
                                <i class="fas fa-info-circle text-primary font-size-sm ms-2"> </i>
                            </a>
                        </a>
                        <div class="d-flex justify-content-start ms-auto py-2 px-3">
                            <button type="button" class="btn btn-primary" @click="goToReportCenter()">
                                Report Center
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tab-content" id="v-pills-tabContent">
                <section class="px-3 mb-2">
                    <HuvSfvStatusReportHos />
                </section>
            </div>
        </div>
    </section>
</template>

<style src="./HuvSfvStatusReport.scss"></style>
<script src="./HuvSfvStatusReport.ts" lang="ts"></script>
